import './LeftPanelWrapper.scss';

import Box from 'fe-design-base/atoms/Box';

import { moment } from 'util/dateTime';

import LeftPanel from './LeftPanel';
import LeftPanelEOY2025 from './LeftPanelEOY2025';

const LeftPanelWrapper = () => {
  const fallbackAt = moment('2026-02-01T00:00:00', 'YYYY-MM-DDTHH:mm:ss');
  const shouldShowEOY2025 = moment().isBefore(fallbackAt);

  return (
    <Box w="50%" h="auto" overflow="hidden">
      {shouldShowEOY2025 ? <LeftPanelEOY2025 /> : <LeftPanel />}
    </Box>
  );
};

export default LeftPanelWrapper;
